import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useToastStore = defineStore('toast', () => {
    const toasts = ref([])
    let nextId = 0

    const add = (message, type = 'info', duration = 3000, key = null) => {
        if (key && toasts.value.some(t => t.key === key)) return

        const id = nextId++
        const toast = { id, message, type, duration, key }
        toasts.value.push(toast)

        if (duration > 0) {
            setTimeout(() => {
                remove(id)
            }, duration)
        }
    }

    const remove = (id) => {
        const index = toasts.value.findIndex(t => t.id === id)
        if (index !== -1) {
            toasts.value.splice(index, 1)
        }
    }

    const success = (message, duration = 3000, key = null) => add(message, 'success', duration, key)
    const error = (message, duration = 5000, key = null) => add(message, 'error', duration, key)
    const info = (message, duration = 3000, key = null) => add(message, 'info', duration, key)
    const warning = (message, duration = 4000, key = null) => add(message, 'warning', duration, key)

    return {
        toasts,
        add,
        remove,
        success,
        error,
        info,
        warning
    }
})
